import { getIntegerIdsFromNexlaCustomCode } from './nexlaCustomCodeUtils';

const GET_CREDENTIAL_CALL_REGEX = /nexla_fn\.call\(\s*['"]getCredential['"]\s*,\s*(\d+)\b/g;

const CREDENTIAL_ID_CAPTURE_INDEX = 1;

export function normalizeCredentialId(credential) {
  if (credential != null && typeof credential === 'object' && 'id' in credential) {
    return credential.id;
  }

  return credential;
}

export function getCredentialIdsFromCustomCode(payload) {
  return getIntegerIdsFromNexlaCustomCode(
    payload,
    GET_CREDENTIAL_CALL_REGEX,
    CREDENTIAL_ID_CAPTURE_INDEX,
  );
}
